export default __webpack_public_path__ + "static/soundr-496099fbdc20cbad3dbe263a416e27ae.png";